/* eslint-disable */
import vuetify, { opts } from "@/plugins/vuetify";
import "@/styles/elevation.scss"

// Recolhe todos os componentes
const requireComponent = require.context("./components", true, /[\w-]+\.vue$/);

// Função de instalação executada pelo Vue.use()
function install(Vue) {
  if (install.installed) return;
  install.installed = true;

  // Para cada nome de arquivo correspondente...
  requireComponent.keys().forEach((fileName) => {
    // Obtém a configuração do componente
    const componentConfig = requireComponent(fileName);
    // Obtém a versão PascalCase do nome do componente
    const componentName = fileName
      .split("/")
      .pop()
      .replace(/\.\w+$/, "");
    // Registra o componente globalmente
    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}

// Cria a definição do módulo para Vue.use()
const plugin = {
  install,
  vuetifyOpts: opts,
};

// Auto-instala quando o Vue é encontrado
let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
  // Isso é necessário pois o npm `npm link` de alguma forma não consegue lidar com o vuetify em componentes/molecules aninhados
  GlobalVue.use(vuetify);
}

// Exportação padrão é a biblioteca como um todo, registrada via Vue.use()
export default plugin;
